import script from "./UserManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagementView.vue?vue&type=script&setup=true&lang=js"

import "./UserManagementView.vue?vue&type=style&index=0&id=13deb14c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13deb14c"]])

export default __exports__